import type { ExportFormat, ExportScope } from './contracts'

/** One key per table or list (or `all`), so a table's id never meets a list's name. */
export function exportScopeKey(scope: ExportScope): string {
  if ('tableId' in scope) return `table:${scope.tableId}`
  if ('list' in scope) return `list:${scope.list}`
  return ALL_EXPORTS_KEY
}

/** The header's Exports: every export of the person's. */
export const ALL_EXPORTS_KEY = 'all'

export const exportsQueryKeys = {
  all: ['exports'] as const,
  list: (scopeKey: string | null) => ['exports', 'list', scopeKey] as const,
  job: (exportId: string) => ['exports', 'job', exportId] as const,
  /** A finished export's short-lived download link (dragging a Recent Exports row out). */
  link: (exportId: string) => ['exports', 'link', exportId] as const,
  /** A zip of several finished exports (dragging a Recent Exports selection out). */
  bundle: (exportIds: string[]) => ['exports', 'bundle', [...exportIds].sort()] as const,
  options: (format: ExportFormat) => ['exports', 'options', format] as const,
  /** The organization's defaults: what an automation's file from data starts from. */
  organizationOptions: (format: ExportFormat) =>
    ['exports', 'options', format, 'organization'] as const,
  preview: (source: unknown, request: unknown) => ['exports', 'preview', source, request] as const,
}
